import React from 'react';

export const FileUpload = (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 18v2h12v-2h2v2c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-2h2zm6-15.4 5.7 5.7-1.4 1.4L13 6.4V16h-2V6.4L7.7 9.7 6.3 8.3 12 2.6z" />
  </svg>
);
